export default "__VITE_ASSET__CaCQ2ym0__"